export enum Funcionalidades {
  menu_instituciones = 0,
  registrar_institucion = 1,
  crear_expediente = 2,
  revisar_expediente = 3,
  revisar_solicitudes = 4,
  revisar_prorrogas = 5,
  revisar_expedientes_aprobados = 6,
  revisar_resoluciones_a_firmar = 7,
  revisar_expedientes_historial = 8,
  revisar_antecedentes = 9,
  revisar_apelaciones = 10,
  ver_plantillas = 11,
  registrar_funcionario= 12,
}

export default Funcionalidades;